import React from 'react';
import type { Location } from '../../types/animatronic';

interface AnimatronicLocationDetailsProps {
  location: Location;
}

const AnimatronicLocationDetails: React.FC<AnimatronicLocationDetailsProps> = ({ location }) => {
  return (
    <div className="bg-background rounded-lg border border-gray-800 p-4">
      <h3 className="font-medium mb-2 text-content-primary">Attraction</h3>
      <p className="text-content-secondary mb-4">{location.attraction}</p>
      
      <h3 className="font-medium mb-2 text-content-primary">Park/Venue</h3>
      <p className="text-content-secondary mb-4">{location.park}</p>

      <h3 className="font-medium mb-2 text-content-primary">GPS Coordinates</h3>
      <p className="text-content-secondary">
        {location.latitude}°, {location.longitude}°
      </p>
    </div>
  );
};

export default AnimatronicLocationDetails;